import React, { useEffect } from 'react';
import Header from '../../components/ui/Header';
import GlobalFilterBar from '../../components/ui/GlobalFilterBar';
import RealTimeHeader from './components/RealTimeHeader';
import AlertBanner from './components/AlertBanner';
import LiveKPICards from './components/LiveKPICards';
import RealTimeTrendChart from './components/RealTimeTrendChart';
import ActivityFeed from './components/ActivityFeed';
import SalesFunnelVisualization from './components/SalesFunnelVisualization';

const RealTimeOperationsMonitoringDashboard = () => {
  useEffect(() => {
    // Set page title
    document.title = 'Real-Time Operations Monitoring - Daily Sales Analytics';
    
    // Listen for emergency refresh events
    const handleEmergencyRefresh = () => {
      console.log('Emergency refresh triggered');
      // In a real app, this would trigger data refresh across all components
    };

    window.addEventListener('emergencyRefresh', handleEmergencyRefresh);
    
    return () => {
      window.removeEventListener('emergencyRefresh', handleEmergencyRefresh);
    };
  }, []);

  return (
    <div className="min-h-screen bg-background">
      {/* Fixed Header */}
      <Header />
      
      {/* Global Filter Bar */}
      <GlobalFilterBar />
      
      {/* Real-Time Header with Live Status */}
      <RealTimeHeader />
      
      {/* Alert Banner */}
      <AlertBanner />
      
      {/* Live KPI Cards - 6 equal-width cards */}
      <LiveKPICards />
      
      {/* Main Content Area */}
      <div className="px-4 lg:px-6 pb-6">
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
          {/* Main Chart Area - 2/3 width on desktop */}
          <div className="xl:col-span-2 space-y-6">
            <RealTimeTrendChart />
            <SalesFunnelVisualization />
          </div>
          
          {/* Right Sidebar - 1/3 width on desktop */}
          <div className="xl:col-span-1">
            <ActivityFeed />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RealTimeOperationsMonitoringDashboard;